import Marquee from "react-fast-marquee";

const items = [
  "Live Life Without Pain",
  "Expert Physiotherapy",
  "Speech & Language Therapy",
  "Advanced Audiology",
  "Rehabilitation Care",
  "Child & Adult Care",
];

export const BrandMarquee = ({ dark = false }) => (
  <div className={`py-6 border-y ${dark ? "border-white/10 bg-dash-ink" : "border-dash-line bg-white"}`} data-testid="brand-marquee">
    <Marquee speed={38} gradient={false} autoFill>
      {items.map((t, i) => (
        <div key={i} className="flex items-center gap-6 px-6">
          <span className={`font-display text-2xl md:text-3xl font-medium ${dark ? "text-white/90" : "text-dash-ink"}`}>{t}</span>
          <span className="h-2 w-2 rounded-full bg-dash-gold" />
        </div>
      ))}
    </Marquee>
  </div>
);
